export const gridClassName =
  'grid grid-cols-[100px_minmax(250px,_1fr)_1fr_120px_minmax(170px,_1fr)] grid-cols-[120px_minmax(250px,_1fr)_1fr_60px_150px] gap-x-2';

export const iconColor = {
  'Pending Review': 'text-[#ffa500]',
};
export const iconClass = {
  'In Progress': 'icon-16-stopwatch-mono',
  'Order On Hold': 'icon-16-stopwatch-mono',
  Submitted: 'icon-16-stopwatch-mono',
  Shipped: 'icon-16-stopwatch-mono',
  'Partially Shipped': 'icon-16-stopwatch-mono',
  Completed: 'icon-16-success-mono',
  Cancelled: 'icon-16-stopwatch-mono',
  'Not Started': 'icon-16-stopwatch-mono',
  New: 'icon-16-stopwatch-mono',
  Approval: 'icon-16-stopwatch-mono',
  Pending: 'icon-16-stopwatch-mono',
  'Pending Address Validation': 'icon-16-stopwatch-mono',
  'Pending Review': 'icon-16-clock-mono',
  'Back Order': 'icon-16-stopwatch-mono',
};
